import { gql, useQuery } from '@apollo/client';
import { isDefinedAndNotNull } from '@pendwa/common/utils/isDefinedAndNotNull.js';
import React from 'react';
import { defaultErrorsHandler } from '../../core/apollo/utils.js';
import { app_store_credentials_is_logged_in } from '../../core/appStore/credentials.js';
import { globalEvents } from '../../core/events/index.js';
import { usePageDataCountry } from './usePageDataCountry.js';
import { usePageDataCurrency } from './usePageDataCurrency.js';
const GRAPHQL_QUERY = gql `
  fragment fragmentPageDataViewer on TypeUser {
    uuid
    name
    user_name
    email
    email_is_confirmed
    phone_number
    permission_roles
    is_banned
    is_approved
    credits
    coins
    created_at {
      iso
    }
    sc_user_context {
      user_uuid
      connection {
        id
      }
      get_started_completed
      is_subscribed
    }
  }

  fragment fragmentPageDataProfile on TypeProfile {
    uuid
    user_uuid
    name
    is_default
    autoplay_next_episode
    autoplay_preview
    avatar_direct {
      uuid
      path
    }
    fallback_avatar_path
  }

  query hooksPageData {
    viewer {
      ...fragmentPageDataViewer
    }
    viewerProfile {
      ...fragmentPageDataProfile
    }
    viewerProfiles {
      ...fragmentPageDataProfile
    }
  }
`;
export const usePageData = () => {
    const result = useQuery(GRAPHQL_QUERY, {
        fetchPolicy: app_store_credentials_is_logged_in ? 'cache-and-network' : 'cache-first',
    });
    // some data needs to be loaded separately so that it is not cached
    const country = usePageDataCountry();
    const currency = usePageDataCurrency();
    defaultErrorsHandler(result.error);
    const eventsRefetch = React.useCallback(() => result.refetch(), [result.refetch]);
    React.useEffect(() => {
        globalEvents.on('USER_CHANGE', eventsRefetch);
        globalEvents.on('PROFILE_CHANGE', eventsRefetch);
        return () => {
            globalEvents.removeListener('USER_CHANGE', eventsRefetch);
            globalEvents.removeListener('PROFILE_CHANGE', eventsRefetch);
        };
    }, [eventsRefetch]);
    return {
        error: result.error,
        refetch: result.refetch,
        loading: result.loading && !result.data,
        viewer: isDefinedAndNotNull(result.data?.viewer) ? result.data.viewer : undefined,
        viewer_profile: isDefinedAndNotNull(result.data?.viewerProfile) ? result.data.viewerProfile : undefined,
        viewer_profiles: isDefinedAndNotNull(result.data?.viewerProfiles) ? result.data.viewerProfiles : [],
        country,
        currency,
    };
};
//# sourceMappingURL=usePageData.js.map